<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><strong><span class="big">PROTECTION</span><br/> <strong><span class="big1">FOR</span></strong><br/> <span class="big">HIRE</span></strong><br/><br/><br/></p>
<p class="center">Protection for Hire Series</p>
<p class="center">- Book One -<br/><br/><br/><br/><br/></p>
<p class="center"><span class="big1"><strong>CAMY TANG</strong></span><br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/zondervan_L01.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?ec2f9f86